"use client";
import BFLLink from "@repo/shared-ui/BFLLink";
import { handleOurCompaniesClickDL } from "./FooterAccordionFunction";

export interface CorporateLink {
  linkTitle?: string;
  linkUrl?: string;
  nodeName?: string;
}
interface OurCompaniesProps {
  corporateLinksTitle: string;
  corporateLinks: CorporateLink[];
}
const OurCompanies = ({ corporateLinksTitle, corporateLinks }: OurCompaniesProps) => {
  const handleClick = (
    e: React.MouseEvent<HTMLElement>,
    linkTitle: string,
    linkUrl: string,
    index: number
  ) => {
    e.preventDefault();
    handleOurCompaniesClickDL(linkTitle, linkUrl, corporateLinksTitle, index);
    window.location.href = linkUrl;
  };

  return (
    <div className="flex w-[40%] flex-col md:w-[18%]">
      <h3 className="text-sm font-medium">{corporateLinksTitle}</h3>
      {corporateLinks?.map((link, index) => (
        <BFLLink
          key={"corpLink-" + index}
          href={link.linkUrl || ""}
          className="mt-2 text-[10px] text-wrap"
          onClick={(e) => handleClick(e, link.linkTitle || "", link.linkUrl || "", index)}
        >
          {link.linkTitle}
        </BFLLink>
      ))}
    </div>
  );
};
export default OurCompanies;
